export function getGridFilterDetails(filterModel: { [key: string]: any }): { query: string, filterFields: string[] } {
	const filterFields: string[] = Object.keys(filterModel);
	const query = filterModel[filterFields[0]]?.filter;

	return {
		query,
		filterFields
	};
}
